export default "__VITE_ASSET__Bn1qREKm__"